import { gql } from "@apollo/client";
import { StreetSweeperGpsEvent } from "./models";

export interface LastStreetSweepByStreetQueryType {
  readonly lastStreetSweepByStreet: ReadonlyArray<StreetSweeperGpsEvent>;
}

export const LAST_STREET_SWEEP_BY_STREET_QUERY = gql`
  query lastStreetSweepByStreetQuery(
    $streetName: String!
    $suburbName: String!
  ) {
    lastStreetSweepByStreet(
      query: {
        streetName: $streetName
        suburbName: $suburbName
        mode: FromFirstSweepToLastSweep
      }
    ) {
      gps_time
      gps_lat
      gps_lon
    }
  }
`;
